import { Box, Typography } from "@mui/material";
import { ReactComponent as ArtWork } from "../../../assets/UsersPageArtWork.svg";

export const Header = ({
  title = "User management",
  description = "Admins can edit user, class and school information on this page. Teachers have access to view information, but cannot edit student information.",
}: {
  title?: string;
  description?: string;
}) => {
  return (
    <Box
      sx={{
        height: "300px",
        width: "100%",
        backgroundColor: "#0E556F",
        display: "flex",
        position: "relative",
      }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          maxWidth: "calc(100% - 740px)",
          marginTop: "103px",
          marginLeft: "86px",
        }}>
        <Typography sx={{ color: "#FAFAFA" }} variant="h2" component="span">
          {title}
        </Typography>
        <Typography sx={{ color: "#FAFAFA" }} variant="h6" component="span">
          {description}
        </Typography>
      </Box>
      <ArtWork
        style={{
          height: "255px",
          width: "555px",
          bottom: "0px",
          right: "0px",
          marginRight: "98px",
          position: "absolute",
        }}
      />
    </Box>
  );
};
